<!-- <div id="slider" class="mt-2 mb-2">
    <div class="container">
        <div class="d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <marquee behavior="scroll" direction="left" class="my-auto"><a href="https://drive.google.com/file/d/1bZKWU6Ixuas4SN92q912IYaxeOnpZ8jG/view?usp=sharing" target="_blank" download class="mr-2">Vacancy for the year 2022. For Advertisement <strong>Click Here.</strong></a>
                        For Download Application Form <a href="https://drive.google.com/file/d/17uOAceSKu1syo3kAtHwpRZg5z9XDF9TA/view?usp=sharing" target="_blank"> <strong>Click Here.</strong></a>
                    </marquee>
                    
                </div>
            </div>
        </div>
    </div>
</div> -->
<div id="slider" class="pt-2 pb-2">
    <div class="container">
        <div class="d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <marquee behavior="scroll" direction="left" class="my-auto">Admission open for session 2026-27
                    </marquee>

                </div>
            </div>
        </div>
    </div>
</div>